export { default as RecentPubCard } from './component';
